// Zkrátit title (dle zařízení)

import { maintainTextLength } from '@utils/text';

export const galleryTrimTitle = (): void => {
  const length = 65;

  const title: HTMLElement | null = document.querySelector('[data-navigation-title]');
  if (title) {
    const { navigationTitle } = title.dataset;
    if (navigationTitle) title.innerText = maintainTextLength(navigationTitle, length);
  }
};
